// export default Projects;
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AtomicSpinner from 'atomic-spinner'
import { useSelector, useDispatch } from 'react-redux';
import { fetchProjects } from './redux/actions/projectsActions';

const Projects = () => {
  const projects = useSelector(state => state.projects);
  const dispatch = useDispatch();

  useEffect(() => {
    if (projects.length === 0) {
      dispatch(fetchProjects());
    }
    console.log(projects)

  }, [dispatch, projects]);

  return (
    <div className="team" id="projects">
      <h2 className="main-title">Projects</h2>
      { projects.length === 0 ? (
        <div className="heading">
          <h1 className="heading">Loading Projects</h1>
          <AtomicSpinner />
        </div>
      ) : (
        <div className="container">
          {projects.map((project, index) => (
            <div className="box" key={project._id}>
              <div className="data">
                <Link
                  to={`/task/${project._id}`}
                  state={{ id: `${project._id}` }}
                >
                  <img
                    src={require(`../../../portfolio-backend/NewImages/${project.name}/${project._id}_0.png`)}
                    alt=""
                  />
                </Link>
                <div className="social">
                  <a href="https://www.facebook.com/abi.mohamed.10" target='_blanck'>
                    <i className="fab fa-facebook-f" target='_blanck'></i>
                  </a>
                  <a href="https://twitter.com/mohamed52568273" target='_blanck'>
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="https://www.linkedin.com/in/mohamed-abi-976299237/" target='_blanck'>
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-youtube" target='_blanck'></i>
                  </a>
                  <a
                    href="https://github.com/mohamedabi17"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="youtube"
                  >
                    <i className="fa fa-github"></i>
                  </a>
                </div>
              </div>
              <div className="info">
                <h3>{project.name}</h3>
                <p>{project.abrev}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Projects;